import { IExplore } from '../explore-model';
import { useExplore } from './use-explore';

export function useExploreMap() {
    const explore: IExplore = useExplore();

    return explore.getExploreMap();
}
